// BEE-157: Simplified single-line footer with logo, copyright, and two links.

import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer
      className="border-t"
      style={{ borderColor: '#e8e3d6', background: 'var(--paper)' }}
    >
      <div
        className="mx-auto flex flex-wrap items-center justify-between gap-x-6 gap-y-3 px-6 py-4"
        style={{ maxWidth: '1240px' }}
      >
        {/* Logo */}
        <Link to="/" aria-label="KindredCanopy home">
          <img src="/Logo_NoText.png" alt="KindredCanopy mark" className="h-6 w-6 object-contain" />
        </Link>

        {/* Copyright */}
        <p className="font-sans text-xs" style={{ color: '#8a8d87' }}>
          © 2026 KindredCanopy · Made with care.
        </p>

        {/* Links */}
        <div className="flex items-center gap-5">
          <Link
            to="/privacy"
            className="font-sans text-xs transition-colors hover:text-ink"
            style={{ color: '#8a8d87' }}
          >
            Privacy &amp; Terms
          </Link>
          <Link
            to="/about"
            className="font-sans text-xs transition-colors hover:text-ink"
            style={{ color: '#8a8d87' }}
          >
            About
          </Link>
        </div>
      </div>
    </footer>
  )
}
